import { render, staticRenderFns } from "./Limit.vue?vue&type=template&id=331b6032&scoped=true&"
import script from "./Limit.vue?vue&type=script&lang=js&"
export * from "./Limit.vue?vue&type=script&lang=js&"
import style0 from "./Limit.vue?vue&type=style&index=0&id=331b6032&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331b6032",
  null
  
)

export default component.exports